import { updateIfRoundTripDiscountShouldShowChanged } from './roundTripDiscountActionCreators'

import { dataChangesActionsCreator } from 'store/toolkit/newBooking/dataChange.reducer'
import { selectedVehicleTypeIDActionsCreator } from 'store/toolkit/newBooking/selectedVehicleTypeID.reducer'

export const changeVehicleType = vehicleTypeID => (dispatch, getState) => {
  Promise.all([
    dispatch(selectedVehicleTypeIDActionsCreator.setSelectedVehicleTypeId(vehicleTypeID))
  ]).then(() => {
    dispatch(updateIfRoundTripDiscountShouldShowChanged(vehicleTypeID))
    dispatch(dataChangesActionsCreator.updateDataChange(true))
  })
}


export default { changeVehicleType }
